(function () {
  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  function showFormMessage(form, type, text) {
    var box = form.querySelector('[data-rb-form-message]');
    if (!box) return;
    box.textContent = text;
    box.hidden = false;
    box.classList.toggle('rb-form-message--error', type === 'error');
    box.classList.toggle('rb-form-message--success', type === 'success');
  }

  function clearFormMessage(form) {
    var box = form.querySelector('[data-rb-form-message]');
    if (!box) return;
    box.hidden = true;
    box.textContent = '';
    box.classList.remove('rb-form-message--error', 'rb-form-message--success');
  }

  function setFieldError(field, hasError) {
    if (!field) return;
    field.classList.toggle('rb-field--error', hasError);
  }

  function initContactForms() {
    document.querySelectorAll('[data-rb-contact-form]').forEach(function (form) {
      if (form.dataset.rbBound === 'true') return;
      form.dataset.rbBound = 'true';

      if (form.classList.contains('rb-form--posted')) {
        showFormMessage(form, 'success', form.dataset.successMessage || 'Thank you. Your message has been sent.');
      }

      if (form.classList.contains('rb-form--errors')) {
        showFormMessage(form, 'error', form.dataset.errorMessage || 'Please check the highlighted fields and try again.');
      }

      form.addEventListener('submit', function (e) {
        clearFormMessage(form);
        var hasError = false;

        form.querySelectorAll('[data-rb-required]').forEach(function (input) {
          var value = input.value.trim();
          var invalid = !value;
          if (input.type === 'email' && value) invalid = !isValidEmail(value);
          setFieldError(input.closest('.rb-field') || input.parentElement, invalid);
          if (invalid) hasError = true;
        });

        if (hasError) {
          e.preventDefault();
          showFormMessage(form, 'error', 'Please complete all required fields.');
        }
      });

      form.querySelectorAll('input, textarea').forEach(function (input) {
        input.addEventListener('input', function () {
          setFieldError(input.closest('.rb-field') || input.parentElement, false);
          clearFormMessage(form);
        });
      });
    });
  }

  function initCoutureForm() {
    var form = document.querySelector('[data-rb-couture-form]');
    if (!form || form.dataset.rbBound === 'true') return;
    form.dataset.rbBound = 'true';

    var fileInput = document.getElementById('rb-file-input');
    var countEl = document.getElementById('rb-file-count');
    var preview = document.getElementById('rb-file-preview');
    var uploadWrap = form.querySelector('.rb-upload-wrap');
    var maxFiles = 5;
    var maxBytes = 10 * 1024 * 1024;
    var selectedFiles = []; // each: { file, objectUrl, url, status }

    // Optional CDN uploads. With a Cloudinary cloud name + unsigned preset set in
    // the section settings, images upload to the CDN and the form submits clickable
    // URLs. With no config it gracefully falls back to sending filenames only.
    var cloudName = uploadWrap ? (uploadWrap.getAttribute('data-cloudinary-cloud') || '').trim() : '';
    var uploadPreset = uploadWrap ? (uploadWrap.getAttribute('data-cloudinary-preset') || '').trim() : '';
    var uploadsEnabled = !!(cloudName && uploadPreset);

    function uploadsBusy() {
      return selectedFiles.some(function (f) { return f.status === 'pending' || f.status === 'uploading'; });
    }

    function renderPreview() {
      if (!preview) return;
      preview.innerHTML = '';
      selectedFiles.forEach(function (entry, index) {
        var item = document.createElement('div');
        item.className = 'rb-file-preview-item';
        if (entry.status === 'pending' || entry.status === 'uploading') item.classList.add('is-uploading');
        if (entry.status === 'error') item.classList.add('is-error');

        var img = document.createElement('img');
        img.alt = entry.file.name;
        if (!entry.objectUrl) entry.objectUrl = URL.createObjectURL(entry.file);
        img.src = entry.objectUrl;
        item.appendChild(img);

        if (entry.status === 'pending' || entry.status === 'uploading') {
          var loading = document.createElement('span');
          loading.className = 'rb-file-status';
          loading.textContent = 'Uploading…';
          item.appendChild(loading);
        } else if (entry.status === 'error') {
          var err = document.createElement('span');
          err.className = 'rb-file-status rb-file-status--error';
          err.textContent = 'Failed';
          item.appendChild(err);
        } else if (entry.status === 'done') {
          var ok = document.createElement('span');
          ok.className = 'rb-file-status rb-file-status--done';
          ok.textContent = '✓';
          item.appendChild(ok);
        }

        var remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'rb-file-preview-remove';
        remove.setAttribute('aria-label', 'Remove image');
        remove.textContent = '×';
        remove.addEventListener('click', function () {
          if (entry.objectUrl) URL.revokeObjectURL(entry.objectUrl);
          selectedFiles.splice(index, 1);
          if (countEl) countEl.textContent = selectedFiles.length + '/' + maxFiles;
          renderPreview();
        });
        item.appendChild(remove);
        preview.appendChild(item);
      });
    }

    function uploadEntry(entry) {
      entry.status = 'uploading';
      renderPreview();
      var data = new FormData();
      data.append('file', entry.file);
      data.append('upload_preset', uploadPreset);
      fetch('https://api.cloudinary.com/v1_1/' + cloudName + '/image/upload', {
        method: 'POST',
        body: data
      })
        .then(function (r) { return r.json(); })
        .then(function (json) {
          if (json && json.secure_url) {
            entry.url = json.secure_url;
            entry.status = 'done';
          } else {
            entry.status = 'error';
          }
          renderPreview();
        })
        .catch(function () {
          entry.status = 'error';
          renderPreview();
        });
    }

    if (fileInput) {
      fileInput.addEventListener('change', function () {
        var incoming = Array.from(fileInput.files || []);
        var errors = [];

        incoming.forEach(function (file) {
          if (!file.type.startsWith('image/')) {
            errors.push(file.name + ' is not an image.');
            return;
          }
          if (file.size > maxBytes) {
            errors.push(file.name + ' exceeds 10MB.');
            return;
          }
          if (selectedFiles.length >= maxFiles) return;
          var entry = { file: file, objectUrl: null, url: null, status: uploadsEnabled ? 'pending' : 'local' };
          selectedFiles.push(entry);
          if (uploadsEnabled) uploadEntry(entry);
        });

        if (countEl) countEl.textContent = selectedFiles.length + '/' + maxFiles;
        renderPreview();
        fileInput.value = '';

        if (errors.length) showFormMessage(form, 'error', errors.join(' '));
      });
    }

    form.addEventListener('submit', function (e) {
      clearFormMessage(form);
      var hasError = false;

      form.querySelectorAll('[data-rb-required]').forEach(function (input) {
        var value = input.value.trim();
        var invalid = !value;
        if (input.type === 'email' && value) invalid = !isValidEmail(value);
        setFieldError(input.closest('.rb-field'), invalid);
        if (invalid) hasError = true;
      });

      var vision = form.querySelector('[name="contact[Your Vision]"]');
      if (vision && !vision.value.trim()) {
        setFieldError(vision.closest('.rb-field'), true);
        hasError = true;
      }

      if (hasError) {
        e.preventDefault();
        showFormMessage(form, 'error', 'Please complete all required fields.');
        return;
      }

      // Hold the submit until any in-flight CDN uploads finish.
      if (uploadsEnabled && uploadsBusy()) {
        e.preventDefault();
        showFormMessage(form, 'error', 'Your images are still uploading — please wait a moment, then submit again.');
        return;
      }

      var noteField = form.querySelector('[name="contact[Reference Images]"]');
      if (!noteField) {
        noteField = document.createElement('input');
        noteField.type = 'hidden';
        noteField.name = 'contact[Reference Images]';
        form.appendChild(noteField);
      }

      var uploadedUrls = selectedFiles
        .filter(function (f) { return f.url; })
        .map(function (f) { return f.url; });

      if (uploadedUrls.length) {
        noteField.value = uploadedUrls.length + ' image(s) uploaded:\n' + uploadedUrls.join('\n');
      } else if (selectedFiles.length) {
        noteField.value =
          selectedFiles.length +
          ' reference image(s) selected: ' +
          selectedFiles.map(function (f) { return f.file.name; }).join(', ') +
          '. Customer will share files by reply email if needed.';
      } else {
        noteField.value = 'No reference images attached.';
      }

      if (fileInput) {
        fileInput.disabled = true;
      }
    });
  }

  function init() {
    initContactForms();
    initCoutureForm();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
